import React from 'react';
import { formatPercent } from 'utils/formatters';
import { ProductPrice } from './ProductPrice';
import { CommonMenuPriceValues, MarkupType } from '../../../types';

export const MarkupValues = ({ markup }: Pick<CommonMenuPriceValues, 'markup'>) => {
  const formatters: Record<MarkupType, (value: number) => React.ReactNode> = {
    [MarkupType.Flat]: (value: number) => <ProductPrice value={value} />,
    [MarkupType.Percentage]: (value: number) => (
      <ProductPrice value={value} formatter={() => formatPercent(value / 100)} />
    ),
  };

  if (!markup || !markup?.type) return '—';

  return formatters[markup.type](markup?.markup ?? 0);
};
